/**
 * Checks if the passed value is a number
 * @param value any value
 */
export function isNumber(value: any) {
    if (!value) {
        return false;
    } else {
        const number = parseInt(value);
        return !isNaN(number);
    }
}

export function splitToNumberArray(value: string, splitChar: string = ",") {
    if (!value) {
        return [];
    }
    return value.split(splitChar).map((val: string) => parseInt(val));
}
// Parsed einen String in eine Gleitkommazahl um. Trennzeichen ist ein Komma oder ein Punkt.
export function stringToNumber(value?: string) {
    if (!value) {
        return 0;
    }
    if (value.includes(",")) {
        value = value.replace(",", ".");
    }
    value = value.trim()
    return parseFloat(value);
}
// Rechnet eine Gleikommazahl in einen String mit Komma als Dezimaltrennzeichen um.
// Es werden immer zwei Nachkommastellen angezeigt.
export function numberToString(value?: number) {
    if (!value) {
        return "0";
    }
    return value.toFixed(2).replace(".", ",").trim();
}
// Funktion zum kaufmännischen Runden
export function roundTo(num: number, places: number) {
    const factor = 10 ** places;
    return Math.round(num * factor) / factor;
}

// Funktion zum Umwandeln eines unix timestamps in ein Datum
export function numberToDate(value: number | undefined): string {
    const DATE_FORMAT = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    } as Intl.DateTimeFormatOptions;
    if (value) {
        return new Date(value).toLocaleString('de-DE', DATE_FORMAT);
    } else {
        return '';
    }
}
